import React from 'react';
export type DataKind = 'pulse' | 'interpretation' | 'editorial';
interface DataTagProps {
  kind: DataKind;
  detail?: string;
}
const STYLES: Record<DataKind, {
  label: string;
  className: string;
}> = {
  pulse: {
    label: 'Original Pulse responses',
    className: 'bg-navy-900 text-white'
  },
  interpretation: {
    label: 'New interpretation responses',
    className: 'bg-pulse-iris/10 text-pulse-iris'
  },
  editorial: {
    label: 'Editorial observation',
    className: 'bg-mist-200 text-slate-600'
  }
};
export function DataTag({
  kind,
  detail
}: DataTagProps) {
  const s = STYLES[kind];
  return <span className="inline-flex flex-wrap items-center gap-1.5 text-[10px] font-medium" data-id="element-532" data-mp="2723w68fznxe3">
      <span className={`rounded-full px-2 py-0.5 uppercase tracking-[0.12em] ${s.className}`} data-id="element-533" data-mp="2c0oug2bok6zw">{s.label}</span>
      {detail && <span className="tabular-nums text-slate-400" data-id="element-534" data-mp="comf94a39ys1">{detail}</span>}
      {kind !== 'editorial' && <span className="rounded-full bg-amber-100 px-1.5 py-0.5 uppercase tracking-wider text-amber-800" data-id="element-535" data-mp="hm4g07dyd7oy">Illustrative</span>}
    </span>;
}